import React, { useState, useCallback } from 'react';
import POSLoginPage, { getPosToken, getPosStoreId, clearPosSession } from '../pages/POSLoginPage';
import POSPage from '../pages/POSPage';

export default function POSGate() {
  const [sessionValid, setSessionValid] = useState(() => {
    const token = getPosToken();
    const storeId = getPosStoreId();
    return !!(token && storeId);
  });

  const handleLoggedIn = useCallback(() => {
    setSessionValid(true);
  }, []);

  const handleLogout = useCallback(() => {
    clearPosSession();
    setSessionValid(false);
  }, []);

  if (sessionValid) {
    return <POSPage onLogout={handleLogout} />;
  }

  return <POSLoginPage onLoggedIn={handleLoggedIn} />;
}
